module.exports = __webpack_public_path__ + "static/social-526e56d30b206721f9c85ccfa3a52364.png";